import React, { useState, useEffect, Fragment } from 'react';
import {List, ListItem, ListItemText, Divider, TextField, Tooltip} from '@material-ui/core';
import {LockOpen, Delete, Save, Add, Folder, CheckCircle, AccountCircle} from '@material-ui/icons';
import {REMOVE_USER, RESET_PASSWORD} from '../../admin.gql';
import {useMutation} from 'react-apollo';
import Button from '@material-ui/core/Button';

export default function UserList ({data, projects, state}) {
    const { 
        body: [selectedUser, setSelectedUser] 
    } = { 
        body: useState(null), ...(state||null) 
    };
    const [tabState, setTabState] = useState('description');

    const handleUserEdit = (event) => {
        setSelectedUser({...selectedUser, [event.target.name]: event.target.value})
    };
    const handleUserCheckboxEdit = (event) => {
        setSelectedUser({...selectedUser, [event.target.name]: event.target.checked})
    };
    const handleUserProjects = (arr) => {
        setSelectedUser({...selectedUser, accessAuthorizations: arr});
    };
    const handleUserSelection = (selected) => {
        setSelectedUser(selected);
    };
    const handleTabsChange = (state) => {
        setTabState(state)
    }
    // console.log(selectedUser);

    return (
        <div style={{display:'flex'}}>
            <div style={{minWidth:200, marginRight: 15}}>
                <div style={{maxHeight:460, overflow:'auto'}}>
                    <List>
                        { 
                            data.users.map( (user, i) => {
                                const {username, name} = user;
                                return (
                                    <div key={i}>
                                        <Fragment>
                                            <ListItem button onClick={() => {handleUserSelection(user)}}>
                                                <ListItemText primary={username} secondary={name}/>
                                            </ListItem>
                                        </Fragment>
                                        <Divider/>
                                    </div>
                                );
                            })
                        }
                    </List>
                </div>
                <Button 
                    color="primary" variant="contained" 
                    style={{textTransform:'none', width:'100%', display:'flex', justifyContent:'space-around', alignItems:'center'}}
                    onClick={() =>{setSelectedUser({id:null, name:'', username:'', password:'', isAdmin:false, accessAuthorizations:[{id:null, canPerformActions:false}]})}}
                >
                    <Add/>Benutzer anlegen
                </Button>
            </div>
            {
                !selectedUser && <div style={{minWidth:300, height:500 , border:'1px solid #dadada'}}/>
            }
            {
                (selectedUser && tabState === 'description')?
                <UserDescription user={selectedUser} onState={handleTabsChange} onTextEdit={handleUserEdit} onCheckboxEdit={handleUserCheckboxEdit}/>:null
            }
            {
                (selectedUser && tabState === 'projects')?
                <UserProjects user={selectedUser} onState={handleTabsChange} onEdit={handleUserProjects} projects={projects.projects} />:null
            }
        </div>
    );
};

function UserDescription({user, onState, onTextEdit, onCheckboxEdit}){
    const {id, name, username, password, isAdmin, accessAuthorizations} = user;
    const [userDescription, setUserDescription] = useState({
        id: id, 
        name: name, 
        username: username, 
        password: password,
        isAdmin: isAdmin,
        accessAuthorizations:accessAuthorizations
    });
    const [removeUser] = useMutation(REMOVE_USER);
    const [resetPassword] = useMutation(RESET_PASSWORD);

    const handleChange = (event) => {
        event.persist();
        setUserDescription({...userDescription, [event.target.name]: event.target.value});
        onTextEdit(event);
    };

    const handleCheckboxChange = (event) => {
        event.persist();
        setUserDescription({...userDescription, [event.target.name]: event.target.checked});
        onCheckboxEdit(event);
    };

    useEffect(()=>{
        const {id, name, username, isAdmin, accessAuthorizations} = user;
        setUserDescription({
            id: id, 
            name: name, 
            username: username,
            password: password, 
            isAdmin: isAdmin,
            accessAuthorizations:accessAuthorizations
        })
        // onChange({...user});
    },[user])

    return (
        <div style={{minWidth:300, height:500 , border:'1px solid #dadada'}}>
            <div style={{width:'100%', height:'90%', display:'flex', flexDirection:'column', justifyContent:'space-around', alignItems:'center'}}>
                <TextField label='Name' InputLabelProps={{shrink:true}} value={userDescription.name} name='name' onChange={handleChange}/>
                <TextField label='Benutzername' InputLabelProps={{shrink:true}} value={userDescription.username} name='username' onChange={handleChange}/>
                {!id && <TextField label='Passwort' InputLabelProps={{shrink:true}} value={userDescription.password} name='password' onChange={handleChange}/>}
                <div style={{width:'50%', display:'flex', justifyContent:'center'}}>
                    <input type='checkbox' checked={userDescription.isAdmin} name='isAdmin' onChange={handleCheckboxChange}/> 
                    <p style={{marginLeft:15, fontFamily:'Arial, Helvetica, sans-serif'}}>Admin</p> 
                </div>
                <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
                    <Button onClick={() => {onState('projects')}}><Folder/><p style={{marginLeft:15, textTransform:'none'}}>Projekte</p></Button>
                </div>
            </div>
            <div style={{width:'100%', height:'10%', display:'flex', justifyContent:'space-around'}}>
                { id && 
                <Tooltip title={<span>Passwort zurücksetzen auf 5wG-3rZ</span>} placement="top">
                    <Button onClick={async () => {
                        if (window.confirm(`Möchten Sie den Passwort von ${userDescription.name} zurücksetzen?`)){
                            try{
                                await resetPassword({variables:{ id:userDescription.id }});
                                window.location.reload();
                            }catch(e){
                                console.log(e)
                            }
                        }
                    }}> 
                        <LockOpen/> 
                    </Button> 
                </Tooltip>}
                
                { id && 
                <Tooltip title={<span>Benuzter löschen</span>} placement="top">
                    <Button onClick={async () => {
                        if (window.confirm(`Möchten Sie ${userDescription.name} löschen?`)){
                            try{
                                await removeUser({variables:{ id:userDescription.id }});
                                window.location.reload();
                            }catch(e){
                                console.log(e)
                            }
                        }
                    }}> 
                        <Delete/> 
                    </Button> 
                </Tooltip>}
                {/* <Button> <Save/> </Button> */}
            </div>
        </div>
    );
}

function UserProjects({user, projects, onState, onEdit}){
    const { id:user_id, name, accessAuthorizations } = user;
    const [userProjects, setUserProjects] = useState(accessAuthorizations);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isProjectVisible, setIsProjectVisible] = useState(false);
    const [canPerformActions, setCanPerformActions] = useState(false);

    const handleUserProjectChange = () => {
        const arr = accessAuthorizations.filter(el => {return el.id !== null && el.id!==selectedProject.id});
        if (selectedProject && isProjectVisible){
            arr.push({id:selectedProject.id, canPerformActions:canPerformActions})
            onEdit( arr );
        }else if (selectedProject && !isProjectVisible){
            const filtarr = accessAuthorizations.filter(el => {return el.id !== selectedProject.id});
            onEdit( filtarr );
        }
    }

    const handleProjectVisibleChange = (event) => {
        event.persist();
        setIsProjectVisible(event.target.checked);
    };
    const handlePerformActionsChange = (event) => {
        event.persist();
        setCanPerformActions(event.target.checked);
    };

    useEffect(()=>{
        const {accessAuthorizations: user_projects} = user;
        setUserProjects(user_projects);
        setSelectedProject(null);
        setIsProjectVisible(false);
        setCanPerformActions(false)
    },[user])

    useEffect(() => {
        if (selectedProject){
            const objectFound = accessAuthorizations.find(el => el.id === selectedProject.id);
            setIsProjectVisible(objectFound?true:false);
            setCanPerformActions(objectFound?objectFound.canPerformActions:false);
        }
    },[selectedProject])

    return (
        <div style={{minWidth:300, height:500 , border:'1px solid #dadada'}}>
            <div style={{width:'100%', height:'90%', display:'flex', flexDirection:'column', justifyContent:'space-around', alignItems:'center'}}>
                <div style={{width:'90%', margin:'5%', height:30, border:'1px solid #dadada', display:'flex', alignItems:'center', }}> 
                    <p style={{fontSize:12, marginLeft:15, fontFamily:'Arial, Helvetica, sans-serif'}}>{ name }</p> 
                </div>
                <List>
                    { 
                        projects.map( (project, i) => {
                            const {id: project_id, name} = project;
                            const checkedProject = userProjects?userProjects.find(el => el.id === project_id):null;
                            return (
                                <div key={i} style={{border:(selectedProject && project_id === selectedProject.id)?'2px solid green':null}}>
                                    <div style={{display:'flex'}}>
                                        <ListItem button onClick={() => {setSelectedProject(project)}}>
                                            <ListItemText primary={name}/>
                                            <div style={{display:'flex', flexDirection:'column', marginLeft:10}}>
                                                { checkedProject && <CheckCircle style={{width:10}}/>}
                                                { checkedProject && checkedProject.canPerformActions && <CheckCircle style={{width:10}}/>}
                                            </div>
                                        </ListItem>
                                        <Button 
                                            onClick={() => {
                                                if (selectedProject){
                                                    handleUserProjectChange()
                                                } else {
                                                    document.getElementById('fehlermeldung-projects').innerHTML = 'Klicken Sie zuerst auf den Projektnamen und wählen Sie die Zugriffsrechte in der Box unten'
                                                }
                                                
                                            }}
                                        > <Save/> </Button>
                                    </div>
                                    <Divider/>
                                </div>
                            );
                        })
                    }
                </List>
                <div style={{width:'90%', padding:10, minHeight:75, border:'1px solid #dadada', display:'flex', flexDirection:'column', justifyContent:'space-around' }}>
                    <div style={{fontFamily:'Arial, Helvetica, sans-serif', fontSize:12, display:'flex', justifyContent:'space-around'}}>
                        <p> Projekt angezeigt </p>
                        <input type='checkbox' checked={isProjectVisible} onChange={handleProjectVisibleChange}/>
                    </div> 
                    <div style={{fontFamily:'Arial, Helvetica, sans-serif', fontSize:12, display:'flex', justifyContent:'space-around'}}>
                        <p> Steuerung aktiviert </p>
                        <input type='checkbox' checked={canPerformActions} onChange={handlePerformActionsChange}/>
                    </div> 
                </div>
                <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
                    <Button onClick={() => {onState('description')}}><AccountCircle/><p style={{marginLeft:15, textTransform:'none'}}>Beschreibung</p></Button>
                </div>
            </div>
            <p id='fehlermeldung-projects' style={{ fontSize:12, color:'red', margin:'2%', fontFamily:'Arial, Helvetica, sans-serif'}}/>
            {/* <div style={{width:'100%', height:'10%', display:'flex', justifyContent:'space-around'}}>
                { user_id && <Button> <LockOpen/> </Button> }
                { user_id && <Button> <Delete/> </Button> }
            </div> */}
        </div>
    );
}